// access-control.service.ts
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmMessageDialogService } from 'src/app/components/shared/confirm-message-dialog.service';
import { GeneralMessageDialogSetting } from 'src/app/models/general-message-dialog-setting';
import { LoginService } from 'src/app/service/login.service';
import { SharedFunctionService } from 'src/app/service/shared.function.service';

@Injectable({
  providedIn: 'root',
})
export class AccessControlService {
  loginService = inject(LoginService);
  router = inject(Router);
  confirmDialog = inject(ConfirmMessageDialogService);
  sharedFunction = inject(SharedFunctionService);

  hasAccess(role: string): boolean {
    return this.loginService.checkUserAccessRole(role);
  }

  handleAccessDenied(): void {
    this.sharedFunction.closeDinoLoading();
    const messageSetting = new GeneralMessageDialogSetting();
    messageSetting.Title = 'Alert';
    messageSetting.NeedYesBtn = false;
    // the sharedFunction requiredData is undefined
    messageSetting.Message = this.sharedFunction.getUiMessageByCode(
      'Share-WARNING-AccessDeny',
      'Access deny. Please subscription the right plan.'
    );
    this.confirmDialog.confirm(messageSetting).subscribe(() => {
      this.router.navigate(['/research/subscription/plan']);
    });
  }

  redirectToHome(): boolean {
    if (!this.loginService.isLogin() && !this.loginService.getCurrentLoginUserName()) {
      this.loginService.logout();
      return false;
    }
    return true;
  }
}
